














import { Component, Vue } from 'vue-property-decorator';
import Navigation from '@/components/navigation-bar.vue';
import Footer from '@/components/footer.vue';

@Component({
    components: {
        'navigation-bar': Navigation,
        'footer-info': Footer,
    },
})
export default class ApplicationLayout extends Vue {}
